import React from 'react';

import { SvgProps } from '../enums';

export const FlagVG: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55189"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55189)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#2E42A5"
      />
      <mask
        id="mask1_270_55189"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55189)">
        <mask
          id="mask2_270_55189"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="9"
          height="7"
        >
          <rect width="9" height="7" fill="white" />
        </mask>
        <g mask="url(#mask2_270_55189)">
          <path
            // eslint-disable-next-line max-len
            d="M-1.00214 6.49987L0.978339 7.36847L9.04494 0.94433L10.0896 -0.346436L7.97176 -0.636747L4.68159 2.1316L2.03334 3.99682L-1.00214 6.49987Z"
            fill="#F7FCFF"
          />
          <path
            d="M-0.731018 7.10849L0.277943 7.61255L9.71445 -0.466309H8.29775L-0.731018 7.10849Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M10.0021 6.49987L8.02166 7.36847L-0.0449371 0.94433L-1.08959 -0.346436L1.02824 -0.636747L4.31841 2.1316L6.96666 3.99682L10.0021 6.49987Z"
            fill="#F7FCFF"
          />
          <path
            // eslint-disable-next-line max-len
            d="M9.93457 6.93667L8.92561 7.44073L4.90745 3.98176L3.71615 3.59529L-1.1901 -0.341973H0.226597L5.13009 3.50184L6.43256 3.96525L9.93457 6.93667Z"
            fill="#F50100"
          />
          <mask
            id="path-9-outside-1_270_55189"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="11"
            height="9"
            fill="black"
          >
            <rect fill="white" x="-1" y="-1" width="11" height="9" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M3.99226 0V-0.75H3.24226V0H3.99226ZM4.99226 0H5.74226V-0.75H4.99226V0ZM3.99226 3V3.75H4.74226V3H3.99226ZM0 3V2.25H-0.75V3H0ZM0 4H-0.75V4.75H0V4ZM3.99226 4H4.74226V3.25H3.99226V4ZM3.99226 7H3.24226V7.75H3.99226V7ZM4.99226 7V7.75H5.74226V7H4.99226ZM4.99226 4V3.25H4.24226V4H4.99226ZM9 4V4.75H9.75V4H9ZM9 3H9.75V2.25H9V3ZM4.99226 3H4.24226V3.75H4.99226V3ZM3.99226 0.75H4.99226V-0.75H3.99226V0.75ZM4.74226 3V0H3.24226V3H4.74226ZM0 3.75H3.99226V2.25H0V3.75ZM0.75 4V3H-0.75V4H0.75ZM3.99226 3.25H0V4.75H3.99226V3.25ZM4.74226 7V4H3.24226V7H4.74226ZM4.99226 6.25H3.99226V7.75H4.99226V6.25ZM4.24226 4V7H5.74226V4H4.24226ZM9 3.25H4.99226V4.75H9V3.25ZM8.25 3V4H9.75V3H8.25ZM4.99226 3.75H9V2.25H4.99226V3.75ZM4.24226 0V3H5.74226V0H4.24226Z"
            fill="#F7FCFF"
            mask="url(#path-9-outside-1_270_55189)"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M10.1234 5.01636V8.28093C10.1234 8.28093 10.075 10.982 12.5643 10.982C15.0537 10.982 15.0537 8.28093 15.0537 8.28093V5.01636H10.1234Z"
          fill="#3B7E05"
          stroke="#F7FCFF"
          strokeWidth="0.25"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M10.1185 9.94436L10.5151 9.5462C11.1349 10.3117 11.7868 10.6842 12.48 10.6842C13.1731 10.6842 13.8244 10.3117 14.4432 9.54636L14.669 9.77265L14.6785 9.75846C14.8165 9.87529 14.9075 9.98461 14.9512 10.1112C15.0224 10.3175 14.9464 10.5157 14.7796 10.6205C14.7382 10.6465 14.7054 10.6653 14.6762 10.6789C14.6085 10.7104 14.5542 10.7241 14.4737 10.7014C14.3917 10.6782 14.3228 10.6151 14.2871 10.5283C13.7246 11.0258 13.121 11.2788 12.48 11.2788C11.8444 11.2788 11.2454 11.0301 10.6865 10.541C10.6492 10.6264 10.5795 10.6877 10.4976 10.7093C10.4167 10.7306 10.3626 10.7159 10.2955 10.6833C10.2666 10.6692 10.2341 10.6499 10.1932 10.6231C10.0282 10.5154 9.95572 10.3159 10.0305 10.1109C10.0508 10.0552 10.0834 10.0034 10.1257 9.95315C10.1233 9.95022 10.1209 9.94729 10.1185 9.94436Z"
          fill="#FFD018"
        />
        <path
          // eslint-disable-next-line max-len
          d="M10.5151 9.5462L10.5734 9.49901L10.5209 9.43414L10.462 9.49328L10.5151 9.5462ZM10.1185 9.94436L10.0654 9.89143L10.0178 9.93918L10.0602 9.99155L10.1185 9.94436ZM14.4432 9.54636L14.4963 9.49339L14.4374 9.4343L14.3849 9.49921L14.4432 9.54636ZM14.669 9.77265L14.6159 9.82562L14.6802 9.89009L14.7311 9.81462L14.669 9.77265ZM14.6785 9.75846L14.727 9.70121L14.6632 9.64718L14.6164 9.71649L14.6785 9.75846ZM14.9512 10.1112L15.0221 10.0868V10.0868L14.9512 10.1112ZM14.7796 10.6205L14.7397 10.557V10.557L14.7796 10.6205ZM14.6762 10.6789L14.6445 10.6109L14.6762 10.6789ZM14.4737 10.7014L14.494 10.6292V10.6292L14.4737 10.7014ZM14.2871 10.5283L14.3565 10.4998L14.3164 10.4022L14.2374 10.4721L14.2871 10.5283ZM10.6865 10.541L10.7359 10.4846L10.6588 10.4172L10.6178 10.511L10.6865 10.541ZM10.4976 10.7093L10.4785 10.6368H10.4785L10.4976 10.7093ZM10.2955 10.6833L10.3284 10.6158H10.3284L10.2955 10.6833ZM10.1932 10.6231L10.1521 10.6859H10.1521L10.1932 10.6231ZM10.0305 10.1109L10.1009 10.1366L10.0305 10.1109ZM10.1257 9.95315L10.1831 10.0014L10.2229 9.95393L10.1838 9.90584L10.1257 9.95315ZM10.462 9.49328L10.0654 9.89143L10.1717 9.99729L10.5682 9.59913L10.462 9.49328ZM12.48 10.6092C11.8174 10.6092 11.1849 10.2542 10.5734 9.49901L10.4568 9.5934C11.0849 10.3691 11.7562 10.7592 12.48 10.7592V10.6092ZM14.3849 9.49921C13.7744 10.2543 13.1424 10.6092 12.48 10.6092V10.7592C13.2037 10.7592 13.8744 10.3692 14.5015 9.59352L14.3849 9.49921ZM14.722 9.71968L14.4963 9.49339L14.3901 9.59933L14.6159 9.82562L14.722 9.71968ZM14.6164 9.71649L14.6068 9.73069L14.7311 9.81462L14.7407 9.80042L14.6164 9.71649ZM15.0221 10.0868C14.9721 9.94168 14.8694 9.82177 14.727 9.70121L14.6301 9.8157C14.7637 9.92881 14.843 10.0275 14.8803 10.1357L15.0221 10.0868ZM14.8195 10.684C15.016 10.5605 15.1045 10.3257 15.0221 10.0868L14.8803 10.1357C14.9402 10.3092 14.8767 10.4709 14.7397 10.557L14.8195 10.684ZM14.7078 10.7469C14.7412 10.7313 14.7771 10.7107 14.8195 10.684L14.7397 10.557C14.6994 10.5824 14.6696 10.5992 14.6445 10.6109L14.7078 10.7469ZM14.4533 10.7736C14.5023 10.7874 14.5465 10.7909 14.5902 10.7847C14.633 10.7787 14.6712 10.7639 14.7078 10.7469L14.6445 10.6109C14.6135 10.6253 14.5907 10.6332 14.5693 10.6362C14.5488 10.6391 14.5257 10.6381 14.494 10.6292L14.4533 10.7736ZM14.2177 10.5568C14.2614 10.663 14.3472 10.7436 14.4533 10.7736L14.494 10.6292C14.4361 10.6129 14.3842 10.5672 14.3565 10.4998L14.2177 10.5568ZM12.48 11.3538C13.1426 11.3538 13.7633 11.0917 14.3368 10.5845L14.2374 10.4721C13.686 10.9599 13.0994 11.2038 12.48 11.2038V11.3538ZM10.6371 10.5975C11.207 11.0962 11.823 11.3538 12.48 11.3538V11.2038C11.8658 11.2038 11.2837 10.964 10.7359 10.4846L10.6371 10.5975ZM10.5167 10.7818C10.6226 10.7539 10.7095 10.6756 10.7552 10.5711L10.6178 10.511C10.5888 10.5773 10.5363 10.6215 10.4785 10.6368L10.5167 10.7818ZM10.2627 10.7507C10.299 10.7684 10.337 10.7838 10.3796 10.7906C10.4232 10.7975 10.4675 10.7948 10.5167 10.7818L10.4785 10.6368C10.4467 10.6451 10.4235 10.6457 10.4031 10.6425C10.3818 10.6391 10.3592 10.6308 10.3284 10.6158L10.2627 10.7507ZM10.1521 10.6859C10.1941 10.7133 10.2296 10.7346 10.2627 10.7507L10.3284 10.6158C10.3035 10.6037 10.274 10.5864 10.2342 10.5603L10.1521 10.6859ZM9.95999 10.0852C9.8734 10.3227 9.95782 10.559 10.1521 10.6859L10.2342 10.5603C10.0987 10.4718 10.038 10.3091 10.1009 10.1366L9.95999 10.0852ZM10.0682 9.90491C10.022 9.95991 9.98408 10.0191 9.95999 10.0852L10.1009 10.1366C10.1175 10.0912 10.1448 10.0469 10.1831 10.0014L10.0682 9.90491ZM10.0602 9.99155C10.0626 9.99453 10.065 9.99749 10.0675 10.0005L10.1838 9.90584C10.1815 9.90295 10.1792 9.90006 10.1768 9.89716L10.0602 9.99155Z"
          fill="white"
        />
        <path
          // eslint-disable-next-line max-len
          d="M11.0658 7.3244L11.028 7.16038V5.77118C11.028 5.56407 11.1959 5.39618 11.403 5.39618C11.6101 5.39618 11.778 5.56407 11.778 5.77118V7.07401L12.1378 7.81371C12.2101 7.96231 12.1766 8.14071 12.0553 8.25295L11.6418 8.63559V9.35587C11.6418 9.56298 11.474 9.73087 11.2668 9.73087C11.0597 9.73087 10.8918 9.56298 10.8918 9.35587V8.4717C10.8918 8.36721 10.9354 8.26746 11.0121 8.19649L11.3416 7.89153L11.0658 7.3244Z"
          fill="#FFD018"
        />
        <path
          d="M13.6255 5.74982V9.45219"
          stroke="#FFD018"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.3199 6.29285L12.1517 6.83958C12.1517 6.83958 11.8699 7.20409 11.818 7.38271C11.766 7.56134 11.7375 7.68003 11.7518 7.68003C11.766 7.68003 11.8811 7.62917 11.8811 7.50594C11.8811 7.38271 12.3199 6.98644 12.3199 6.98644L12.4508 6.29285H12.3199Z"
          fill="#FFC6B5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M13.6859 5.43444C13.6899 5.42665 13.6922 5.41767 13.6922 5.40812C13.6922 5.37827 13.6698 5.35406 13.6422 5.35406C13.6146 5.35406 13.5922 5.37827 13.5922 5.40812C13.5922 5.42099 13.5964 5.43281 13.6033 5.44209L13.4141 5.73505L13.4338 5.75083L13.6229 5.45801C13.6289 5.46069 13.6354 5.46217 13.6422 5.46217C13.6519 5.46217 13.661 5.45917 13.6687 5.45397L13.8677 5.75102L13.8871 5.73486L13.6859 5.43444ZM13.6791 5.68786C13.6872 5.67825 13.6922 5.66543 13.6922 5.65136C13.6922 5.62151 13.6698 5.59731 13.6422 5.59731C13.6146 5.59731 13.5922 5.62151 13.5922 5.65136C13.5922 5.66957 13.6005 5.68567 13.6133 5.69546L13.5659 5.75248H13.2447C13.2447 5.75248 13.2799 5.83299 13.3894 5.85425C13.4228 5.88604 13.5084 5.9452 13.5084 5.9452L13.4596 6.00447H13.8059V5.9452C13.8903 5.94457 13.922 5.87794 13.9333 5.85416C13.9379 5.84435 13.9391 5.84183 13.9391 5.85425C13.9391 5.89677 14.0007 5.85425 14.0007 5.85425C14.0007 5.85425 14.103 5.75248 14.103 5.65549C14.103 5.5585 13.8892 5.75248 13.8892 5.75248H13.7441L13.6791 5.68786Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.73 6.074C12.7348 6.08397 12.7383 6.09146 12.7383 6.10201C12.7383 6.13354 12.6047 6.17983 12.5083 6.17983C12.4119 6.17983 12.4497 6.10201 12.5083 6.05885C12.5669 6.01569 12.5036 5.94141 12.4497 5.94141C12.3986 5.94141 12.3987 5.86915 12.3989 5.81109C12.3989 5.80802 12.3989 5.80499 12.3989 5.80201V5.57577C12.3989 5.485 12.4235 5.49563 12.4705 5.51595C12.4981 5.52791 12.5335 5.54321 12.5762 5.54321C12.648 5.54321 12.652 5.55974 12.6627 5.60449C12.6693 5.63168 12.6783 5.66929 12.7066 5.71994C12.7516 5.80059 12.7425 5.81915 12.728 5.84837C12.7185 5.8677 12.7066 5.89169 12.7066 5.94141C12.7066 6.02451 12.7207 6.05417 12.73 6.074ZM12.8491 6.65428L12.8775 6.34678C12.8775 6.34678 12.8491 6.2343 12.9155 6.2343C12.982 6.2343 13.0851 6.77209 13.1224 6.9877C13.1463 7.12559 13.1244 7.15118 13.0611 7.22508C13.0254 7.26674 12.9767 7.32374 12.9155 7.42485C12.8138 7.59304 12.8204 7.69146 12.8254 7.76646C12.8287 7.81655 12.8314 7.85619 12.8006 7.89918C12.7291 7.99913 12.6998 7.90455 12.6712 7.81227C12.6691 7.80541 12.667 7.79856 12.6648 7.79181C12.6375 7.70549 12.7621 7.44383 12.8467 7.2661C12.8578 7.24286 12.8682 7.22105 12.8775 7.20126C12.9576 7.03013 12.9501 6.9704 12.9155 6.89874C12.881 6.82707 12.8491 6.65428 12.8491 6.65428Z"
          fill="#FFC6B5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M13.0097 9.68484C13.0097 9.76303 12.95 9.82641 12.8762 9.82641C12.8025 9.82641 12.7427 9.76303 12.7427 9.68484C12.7427 9.60666 12.8025 9.54327 12.8762 9.54327C12.95 9.54327 13.0097 9.60666 13.0097 9.68484ZM12.2998 9.72418C12.2399 9.77444 12.1669 9.78604 12.1367 9.7501C12.1066 9.71416 12.1307 9.64429 12.1906 9.59403C12.2505 9.54377 12.3235 9.53216 12.3536 9.5681C12.3838 9.60405 12.3597 9.67392 12.2998 9.72418Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.4755 5.39233C12.4755 5.39233 12.3367 5.42052 12.383 5.49003C12.4292 5.55955 12.3227 5.54157 12.4755 5.55056C12.6284 5.55955 12.6702 5.61519 12.6493 5.6563C12.6284 5.69741 12.6119 5.79949 12.6493 5.86099C12.6867 5.9225 12.6985 6.02953 12.7645 5.97602C12.8305 5.9225 12.9572 5.84898 12.9184 5.75264C12.8796 5.6563 12.934 5.54424 12.8493 5.49003C12.7645 5.43583 12.7455 5.46898 12.697 5.39233C12.6485 5.31568 12.577 5.29458 12.5263 5.34345C12.4755 5.39233 12.4755 5.39233 12.4755 5.39233Z"
          fill="#A95601"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.448 6.08875C12.448 6.08875 12.169 6.4247 12.2147 6.54307C12.2604 6.66144 12.3286 6.66767 12.2945 6.83596C12.2604 7.00426 12.3153 7.26445 12.2147 7.59544C12.1141 7.92644 12.048 8.70304 12.081 8.70304C12.1141 8.70304 12.16 9.13204 12.1205 9.32449C12.081 9.51695 11.8056 9.67796 12.081 9.67796C12.3564 9.67796 12.3891 9.71612 12.4991 9.67796C12.6092 9.63981 12.7654 9.78773 12.7654 9.67796C12.7654 9.56819 12.7771 9.54572 12.861 9.54572C12.9449 9.54572 12.9407 9.54572 13.0149 9.54572C13.0892 9.54572 13.1866 9.61485 13.1866 9.45085C13.1866 9.28685 13.2047 8.93446 13.1098 8.66081C13.0149 8.38717 13.0472 8.56191 12.9541 8.19598C12.899 7.97923 12.8564 7.8932 12.8229 7.81748C12.7998 7.76538 12.7339 7.85685 12.7183 7.77527C12.713 7.74761 12.758 7.5853 12.7585 7.56446C12.7615 7.43454 12.861 7.41243 12.861 7.18894C12.861 6.92961 12.7988 6.64471 12.861 6.50216C12.9232 6.35961 13.0758 6.44532 13.0149 6.30667C12.9541 6.16803 12.9343 6.08875 12.8198 6.08875C12.7053 6.08875 12.448 6.08875 12.448 6.08875Z"
          fill="#F7FCFF"
        />
      </g>
    </g>
  </svg>
);
